import { useAppDispatch } from '../../../../store';

export const useAdminConversationUserHistory = () => {
    const dispatch = useAppDispatch();
    return {};
};
